<template>
  <v-btn
    v-show="id !== ''"
    dark
    color="#FEDCBD"
    x-large min-width="80px" class="mb-2"
    @click="click"
  >事前問診結果
  </v-btn>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({

  setup() {
    const store = useStore()
    const id = computed(() => store.getters['advanceInterview/id'])
    const treatmentConsultationSeq = computed(() => store.getters['apiParams/treatmentConsultationSeq'])
    const jwtToken = computed(() => store.getters['apiParams/jwtToken'])
    const treatmentSerialNumber = computed(() => store.getters['apiParams/treatmentSerialNumber'])

    const click = () => {
      const interviewUrl = `/interview/${id.value}/?bearertoken=${jwtToken.value}&treatmentConsultationSeq=${treatmentConsultationSeq.value}&treatmentSerialNumber=${treatmentSerialNumber.value}`
      open(interviewUrl, '_blank')
    }
    return {
      click,
      id,
      treatmentConsultationSeq,
      jwtToken,
      treatmentSerialNumber
    }
  }
})
</script>
